
"use client";

import { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Button, Offcanvas, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../components/styles/Header.css";
import logo from "../assets/productsec/sunshinylogo.jpeg";
import footerlogo from "../assets/productsec/footerlogo.jpeg";
import "bootstrap/dist/css/bootstrap.min.css";


const solutionItems = [
  {
    title: "Residential Cleaning",
    href: "/solutions/residential",
  },
  {
    title: "Commercial Cleaning",
    href: "/solutions/commercial",
  },
  {
    title: "Industrial Cleaning",
    href: "/solutions/industrial",
  },
  {
    title: "Specialized Cleaning",
    href: "/solutions/specialized",
  },
  {
    title: "Maintenance Services",
    href: "/solutions/maintenance",
  },
  {
    title: "Staff Management",
    href: "/solutions/staff-management",
  },
  {
    title: "Green Cleaning",
    href: "/solutions/green-cleaning",
  },
  {
    title: "Sanitization Services",
    href: "/solutions/sanitization",
  },
];

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleCloseOffcanvas = () => setShowOffcanvas(false);
  const handleShowOffcanvas = () => setShowOffcanvas(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="sticky-top">
      {/* Main navbar */}
      <Navbar bg="white" expand="lg" className={isScrolled ? "shadow-sm py-2" : "py-3"}>
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
  src={footerlogo || "/footer.svg"}
  alt="logo"
  height="100"
  width="150"
  className="d-inline-block align-top me-2 ml-5 footerlogo d-none d-md-block"
/>
             <img
             src={logo || "/logo.svg"}
             alt="logo"
             height="70"
             width="200"
             className="d-inline-block align-top me-2 ml-5"
          /> 
          
            {/* <span className="fw-bold text-primary">SunShiny</span> */}
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleShowOffcanvas} className="border-0" />

          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
            <Nav className="mx-auto">
              <Nav.Link as={Link} to="/" className="px-3 fw-medium" style={{ fontFamily: "Poppins, sans-serif" }}>
               <b>HOME</b> 
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="px-3 fw-medium" style={{ fontFamily: "Poppins, sans-serif" }}>
              <b> ABOUT </b>
              </Nav.Link>
              <Nav.Link as={Link} to="/product" className="px-3 fw-medium" style={{ fontFamily: "Poppins, sans-serif" }}>
               <b>PRODUCT</b> 
              </Nav.Link>
              {/* Dropdown using React Bootstrap components */}
              <NavDropdown
                title="SERVICES"
                id="solutions-dropdown"
                className="px-3 fw-medium"
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                {solutionItems.map((item) => (
                  <NavDropdown.Item
                    key={item.title}
                    as={Link}
                    to={item.href}
                    style={{ fontFamily: "Poppins, sans-serif" }}
                  >
                    {item.title}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              <Nav.Link as={Link} to="/contact" className="px-3 fw-medium" style={{ fontFamily: "Poppins, sans-serif" }}>
               <b>CONTACT</b> 
              </Nav.Link>
            </Nav>
             <Nav.Link as={Link} to="/contact">
            <Button variant="danger" className="ms-lg-3">
             <b> FREE CONSULTATION</b>
            </Button>
            </Nav.Link>
          </Navbar.Collapse>

          {/* Mobile Offcanvas Menu */}
          <Offcanvas show={showOffcanvas} onHide={handleCloseOffcanvas} placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="flex-column">
                <Nav.Link
                  as={Link}
                  to="/"
                  onClick={handleCloseOffcanvas}
                  className="py-2 fw-medium"
                  style={{ fontFamily: "Poppins, sans-serif" }}
                >
                  HOME
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/about"
                  onClick={handleCloseOffcanvas}
                  className="py-2 fw-medium"
                  style={{ fontFamily: "Poppins, sans-serif" }}
                >
                  ABOUT
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/product"
                  onClick={handleCloseOffcanvas}
                  className="py-2 fw-medium"
                  style={{ fontFamily: "Poppins, sans-serif" }}
                >
                  PRODUCT
                </Nav.Link>
                <Accordion className="border-0">
                  <Accordion.Item eventKey="0" className="border-0">
                    <Accordion.Header className="py-2 fw-medium" style={{ fontFamily: "Poppins, sans-serif" }}>
                      SERVICES
                    </Accordion.Header>
                    <Accordion.Body className="ps-3">
                      <Nav className="flex-column">
                        {solutionItems.map((item) => (
                          <Nav.Link
                            key={item.title}
                            as={Link}
                            to={item.href}
                            onClick={handleCloseOffcanvas}
                            className="py-2"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            {item.title}
                          </Nav.Link>
                        ))}
                      </Nav>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Nav.Link
                  as={Link}
                  to="/contact"
                  onClick={handleCloseOffcanvas}
                  className="py-2 fw-medium"
                  style={{ fontFamily: "Poppins, sans-serif" }}
                >
                  CONTACT
                </Nav.Link>
                <div className="mt-3">
                  <Button variant="danger" className="w-100">
                    FREE CONSULTATION
                  </Button>
                </div>
              </Nav>
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
